import { BaseUrlController } from '../base-client/base-url-controller';
import { EAPIDeliveryType } from '../models';
import { EEnvironment } from '@/entities';

const baseUrlController = new BaseUrlController({
  baseUrlEnvKey: 'VITE_APP_API_BASE_URL_MM_GATEWAY',
});
baseUrlController.add(EEnvironment.RELEASE, 'https://web-api.uat.cluster.kznexpess.com');
baseUrlController.add(EEnvironment.DEVELOPMENT, 'https://web-api.dev.cluster.kznexpess.com');
baseUrlController.add(EEnvironment.PRODUCTION, 'https://web-api.mm.ru');

export class MMGatewayConfig {
  static DEFAULT_HEADERS = {
    XService: 'market',
    XStoreCore: '000',
    XDeliveryType: EAPIDeliveryType.PICKUP,
    XDevicePlatform: 'web',
    XAppType: 'mm',

    /** важен, чтобы попасть в эксперимент на беке */
    XDeviceIdExperiment: '4305931f-da36-4f94-bdd6-d393d588ba46',
  };

  static SERVICE = 'market';

  static getBaseUrl() {
    return baseUrlController.getBaseUrl();
  }
}
